export default __webpack_public_path__ + "static/media/1.2fa4f82e.webp";